import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";

import { Button, Stack, Switch } from "@mui/material";

import { api } from "../../../../../utils";
import { IError } from "../../../../../models/ReportPageModels";

interface GetFlagsResponse {
    data: GetFlagsResponseData;
    error: IError;
}
interface GetFlagsResponseData {
    xeroAccess: boolean;
}

interface SaveFlagsRequest {
    xeroAccess: boolean;
}

function FeatureFlags() {
    const { enqueueSnackbar } = useSnackbar();

    const [xeroAccess, setXeroAccess] = useState<boolean>(false);

    useEffect(() => {
        GetFlags();
    }, [])

    const GetFlags = async () => {
        try {
            const response: GetFlagsResponse = await api.get("api/Admin/GetFlags", {
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error == null) {
                setXeroAccess(response.data.xeroAccess);
            }
            else {
                enqueueSnackbar(response.error.description, { variant: "error" });
            }
        }
        catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    const SaveFlags = async () => {
        const body: SaveFlagsRequest = {
            xeroAccess: xeroAccess
        }
        try {
            const response: GetFlagsResponse = await api.post("api/Admin/SaveFlags", {
                json: body,
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error == null) {
                enqueueSnackbar("Saved!", { variant: "success" });
            }
            else {
                enqueueSnackbar(response.error.description, { variant: "error" });
            }
        }
        catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    return (
        <>
            {/* Xero access */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ marginRight: "10px" }}>Xero access: </p>
                <Switch
                    checked={xeroAccess}
                    onChange={(newValue) => { setXeroAccess(newValue.target.checked) }}
                    size="small" />
            </Stack>

            <Button
                variant="outlined"
                onClick={() => SaveFlags()}
                sx={{ width: '82px' }}>
                Save
            </Button>
        </>
    )
}

export default FeatureFlags;